import React from 'react'
import Policy from '../../components/Policy'

const PolicyPage = props => <Policy src={`/policies/${props.file}.html`} />

export default PolicyPage
